import { Application, Controller } from '@hotwired/stimulus';

// will load on all pages
import '../../components/environment_badge/component_controller';

export const application = Application.start();
